import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styled from 'styled-components';
import styles from '../../../styles';
import { PreloadImage } from '../../pages/components';
import { Icon } from '../../../icons';

const Container = styled.div`
  display: flex;
  align-items: center;

  &.clickable {
    cursor: pointer;
  }
  ${props => props.layout === 'column' ? `
  flex-direction: column;
  ` : `
  flex-direction: row;
  `}
  `;

const Flag = styled.figure`
  width: 2.25rem;
  height: 2.25rem;
  overflow: hidden;
  margin: 0.5rem 0;
  `;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  ${props => props.layout === 'column' ? `
  align-items: center;
  ` : `
  align-items: flex-start;
  margin-left: 2rem;
  `}
  `;

const Avatar = styled.figure`
  ${props => props.layout === 'column' ? `
    //width: 13.125rem;
    //height: 13.125rem;
    width: 100%;
    padding-top: 100%;
    margin: 0 auto 1rem;
    `: `
    width: 8rem;
    height: 8rem;
    `}
    z-index: 0;
  overflow: hidden;

  position: relative;
  flex-grow: 0;
  flex-shrink: 0;
  border-radius: 999px;
  contain: layout style paint;
  > div,
  > img {
    position: absolute;
    top: 0;
    left: 0;
  }
  img {
    width: 100%;
    height: auto;
  }

  &.clickable {
    img {
      transition: 0.2s transform ${styles.easing.inOutCubic};
      transform: scale(1)/* translate3d(0,0,0)*/;
    }

    &:before {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.125);
      position: absolute;
      border-radius: inherit;
      content: '';
      transition: 0.2s transform ${styles.easing.inOutCubic};
      transform: scale(0.9)/* translate3d(0,0,0)*/;
    }

    .current-input-mouse &:hover,
    .current-input-touch &:active {
      &:before {
        transform: scale(1)/* translate3d(0,0,0)*/;
      }

      img {
        transform: scale(0.9)/* translate3d(0,0,0)*/;
      }
    }
  }
`;

const Name = styled.span`
  color: ${styles.color.CHARCOAL};
  font-size: 1.75rem;
  font-family: 'ApercuBlack';
  line-height: 1em;
  margin: 0.25em 0;
  white-space: nowrap;
  `;

const Tagline = styled.span`
  color: ${styles.color.SLATE_LIGHT};
  font-size: 1rem;
  font-family: 'ApercuMono';
  line-height: 1.25em;
  white-space: nowrap;
`;

const AvatarComponent = props => {
  const {
    onClick,
    layout,
    className,
    imageSrc,
    firstName,
    tagLine,
    nationality,
  } = props;
  const flag =
    (nationality && styles.countries[nationality] && styles.countries[nationality].flagFilename) || '404';
  const containerClassname = classnames(className, {
    'clickable': onClick
  });
  return (
    <Container className={containerClassname} onClick={onClick} layout={layout}>
      <Avatar className={onClick && 'clickable'} layout={layout}>
        <PreloadImage src={imageSrc} circular />
      </Avatar>
      <Details layout={layout}>
        <Name>{firstName}</Name>
        {tagLine && <Tagline>“{tagLine}”</Tagline>}
        {flag && (
          <Flag>
            <Icon icon={`#icon-flag-${flag}`} />
          </Flag>
        )}
      </Details>
    </Container>
  );
};

AvatarComponent.propTypes = {
  onClick: PropTypes.func,
  layout: PropTypes.string.isRequired,
  className: PropTypes.string,
  imageSrc: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  tagLine: PropTypes.string.isRequired,
  nationality: PropTypes.string,
};

AvatarComponent.defaultProps = {
  layout: 'column',
};

export default AvatarComponent;



// WEBPACK FOOTER //
// ./src/modules/people/components/AvatarComponent.js